import PageLayout from 'examples/LayoutContainers/PageLayout'
import DefaultNavbar from 'examples/Navbars/DefaultNavbar'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Home from './Home'
import Login from './Login'
import visitorRoute from './visitorRoute'
import { useEffect, useState } from 'react'
import { CustomDescrypt } from 'global/func'
import userStore from 'store/userStore'
import { decodeToken, isExpired } from 'react-jwt'
import Opd from './Opd'
import LokasiPekerjaan from './LokasiPekerjaan'
import Tim from './Tim'
import DasarHukum from './DasarHukum'
import Kontak from './Kontak'
import PaketDak from './PaketDak'
import { CardMedia, Grid, Typography } from '@mui/material'

import logo_buton from "assets/images/logo-buton.png"
import ArgonTypography from 'components/ArgonTypography'
import ArgonBox from 'components/ArgonBox'
import Belanja from './PaketPekerjaan/Belanja'
import ProyekStrategis from './ProyekStrategis'

const getHari = (date) => {
    const arrHari = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']

    return arrHari[date.getDay()]
}

const getTanggal = (date) => {
    const arrBulan = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']

    return date.getDate() + ' ' + arrBulan[date.getMonth()] + ' ' + date.getFullYear() + ', ' + date.toLocaleTimeString('en-US',{hour12: false, timeZone: "Asia/Makassar"})
}

const TemplateVisitor = () => {
    const navigate = useNavigate();
    // const user = userStore(state => state.user);
    const { user } = userStore(state => ({ user: state.user }));
    const location = useLocation();

    const [tanggal, setTanggal] = useState(new Date())

    const t = new Date();
    const c = t.getHours() - 12;
    useEffect(() => {
        setInterval(() => {
            setTanggal(new Date());
        }, 1000);
    }, []);

    useEffect(() => {
        console.log(user);
        if (user !== null) {
            const decryptedUser = JSON.parse(CustomDescrypt(user));

            if (!isExpired(decryptedUser)) {
                console.log(decryptedUser);
                const decodedUser = decodeToken(decryptedUser);
                if (decodedUser.role === 'super_admin') {
                    navigate("/admin", { replace: true });
                }
                else if (decodedUser.role === "admin_pembangunan") {
                    navigate("/a-pemb", { replace: true });
                }
                else if (decodedUser.role === "admin_opd") {
                    navigate("/a-pd", { replace: true });
                }
                else if (decodedUser.role === "admin_pimpinan") {
                    navigate("/adminp", { replace: true });
                }
            }
        }
        else {
            // const encryptUserJson = JSON.parse(user);
            // console.log(user);
            return
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, location])


    return (
        <PageLayout
        // background="white"
        >
            <Grid container sx={{ bgcolor: 'dark.main' }} justifyContent="space-between" p={1}>
                <Grid item xs='auto'>
                    <ArgonBox lineHeight={1}>
                        <ArgonBox
                            component="img"
                            src={logo_buton}
                            alt="background"
                            width="60px"
                            sx={{
                                verticalAlign: "middle",
                            }}
                            mr={1}
                        />
                        <ArgonTypography
                            fontWeight="bold"
                            color='white'
                            component='span'
                            sx={{
                                verticalAlign: "middle",
                                fontSize: 40
                            }}
                        >
                            PEMERINTAH KABUPATEN BUTON
                        </ArgonTypography>
                    </ArgonBox>
                </Grid>
                <Grid item xs='auto' mt={2}>
                    <ArgonTypography
                        variant="body"
                        fontWeight="bold"
                        color='white'
                        sx={{
                            verticalAlign: "bottom",
                        }}
                    >
                        {getHari(tanggal)}, {getTanggal(tanggal)}
                    </ArgonTypography>
                </Grid>
            </Grid>
            <DefaultNavbar
                routes={visitorRoute}
            />
            <Routes>
                <Route exact path="" element={<Home />} />
                <Route exact path="opd" element={<Opd />} />
                <Route exact path="belanja/*" element={<Belanja />} />
                <Route exact path="proyek-strategis" element={<ProyekStrategis />} />
                <Route exact path="paket-dak" element={<PaketDak />} />
                <Route exact path="lokasi-pekerjaan" element={<LokasiPekerjaan />} />
                <Route exact path="struktur-tim" element={<Tim />} />
                <Route exact path="dasar-hukum" element={<DasarHukum />} />
                <Route exact path="kontak" element={<Kontak />} />
                <Route exact path="login" element={<Login />} />
            </Routes>
        </PageLayout>
    )
}

export default TemplateVisitor